import {InjectionToken} from '@angular/core';

export const BP_CONFIG = new InjectionToken('mydocma-co-config');


export interface BpConfig {
    apiUrl: string;
    parentApp?: string;
    supportEmail?: string;
}
